import { CircularLoading } from '@myhrbox/myhrbox-frontend-core';
import { PopupMessageType } from 'constants/oAuth';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useParseOAuthRequestEndData } from './hooks';
import { OAuthRequestEndData } from './types';

const OAuth = () => {
  const [searchParams] = useSearchParams();
  const searchObject = Object.fromEntries(searchParams);
  const {
    code,
    popup,
    openerOrigin,
    provider: providerName,
    code_verifier: codeVerifierSnakeCase,
    codeVerifier: codeVerifierCamelCase,
    device_id: deviceIdSnakeCase,
    deviceId: deviceIdCamelCase,
    redirect_uri: redirectUriSnakeCase,
    redirectUri: redirectUriCamelCase,
  } = searchObject;

  const isPopapMode = popup === '1' || Boolean(window.opener);
  const provider =
    providerName === 'vk' || Boolean(deviceIdSnakeCase || deviceIdCamelCase) ? 'vk' : 'yandex';
  const successType =
    provider === 'vk' ? PopupMessageType.vkOAuthSuccess : PopupMessageType.yandexOAuthSuccess;
  const errorType =
    provider === 'vk' ? PopupMessageType.vkOAuthError : PopupMessageType.yandexOAuthError;
  const codeVerifier = codeVerifierCamelCase || codeVerifierSnakeCase;
  const deviceId = deviceIdCamelCase || deviceIdSnakeCase;
  const redirectUri = redirectUriCamelCase || redirectUriSnakeCase;
  const parseOAuthRequestEndData = useParseOAuthRequestEndData();

  const onRequestEnd = (type: PopupMessageType, data?: OAuthRequestEndData) => {
    if (isPopapMode && window.opener) {
      const targetOrigin = openerOrigin || window.location.origin;
      window.opener.postMessage({ type, ...data }, targetOrigin);
      window.close();
      return;
    }

    if (isPopapMode) {
      parseOAuthRequestEndData({ error: 'Не удалось отправить code в окно авторизации' });
    } else {
      parseOAuthRequestEndData(data);
    }
  };

  useEffect(() => {
    if (!code) {
      onRequestEnd(errorType, { error: 'Отсутствует code', provider });
      return;
    }

    onRequestEnd(successType, {
      code,
      provider,
      codeVerifier,
      deviceId,
      redirectUri,
    });
  }, [code, openerOrigin]);

  return <CircularLoading />;
};

export default OAuth;
